import { useMemo } from "react";
import Model from "@tripian/model";
import useUser from "./useUser";

export const useGuestUser = (): boolean => {
  const { user } = useUser();

  return useMemo(() => user?.userType === Model.USER_TYPE.GUEST, [user]);
};
